module.exports = __webpack_public_path__ + "static/img/xyz.01d622c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/xyz.jpg
// module id = Cl1f
// module chunks = 0